import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const LeadershipSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <section ref={ref} className="py-20 sm:py-28 bg-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-1/2 right-0 w-96 h-96 bg-gold-accent/5 rounded-full blur-3xl transform -translate-y-1/2" />
      
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-navy-primary mb-16 text-center">
            Leadership
          </h2>

          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-start">
              {/* Image Column */}
              <motion.div
                className="lg:col-span-2"
                initial={{ opacity: 0, x: -40 }}
                animate={inView ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.8, delay: 0.2 }}
              >
                <div className="relative">
                  <div className="aspect-[3/4] rounded-lg overflow-hidden shadow-xl">
                    <img
                      src="https://static.readdy.ai/image/9cad1acab65e0b4933467abfa9c3db47/7028cdebfb75ad19290a8fa76b0727ab.jpeg"
                      alt="Bhargav Channa Reddy - Founder & CEO"
                      className="w-full h-full object-cover grayscale"
                      style={{ filter: 'grayscale(100%) contrast(1.1)' }}
                    />
                  </div>
                  
                  {/* Decorative Element */}
                  <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-gold-accent/20 rounded-lg -z-10"></div>
                </div>
              </motion.div>

              {/* Content Column */}
              <motion.div
                className="lg:col-span-3"
                initial={{ opacity: 0, x: 40 }}
                animate={inView ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.8, delay: 0.3 }}
              >
                <h3 className="text-2xl sm:text-3xl font-bold text-navy-primary mb-2">
                  Bhargav Channa Reddy
                </h3>
                <p className="text-lg text-gold-accent font-semibold mb-6">
                  Founder & CEO
                </p>

                <div className="text-base text-gray-700 leading-relaxed">
                  <p>
                    Bhargav brings a cross-industry background spanning infrastructure consulting, technology initiatives, and enterprise collaboration. His experience working with public sector organizations, large infrastructure programs, and technology platforms informs the operational philosophy behind True Passage Ventures. As Founder and CEO, he focuses on building structured sourcing processes, strong manufacturing partnerships, and a more transparent global procurement ecosystem.
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default LeadershipSection;
